import { Reducer } from 'redux';
import { AnnouncementActionTypes, AnnouncementState } from 'types';

const initialState: AnnouncementState = {};

const reducer: Reducer<AnnouncementState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case AnnouncementActionTypes.GET_ANNOUNCEMENTS_START: {
      return {
        ...state,
        processing: 'loading',
        announcements: action.payload
      };
    }
    case AnnouncementActionTypes.GET_ANNOUNCEMENTS_SUCCESS: {
      return {
        ...state,
        processing: undefined,
        announcements: action.payload
      };
    }
    case AnnouncementActionTypes.GET_ANNOUNCEMENTS_FAILURE: {
      return {
        ...state,
        processing: undefined,
        error: action.payload
      };
    }
    case AnnouncementActionTypes.GET_LIST_ANNOUNCEMENTS_START: {
      return {
        ...state,
        processing: 'loading',
        listAnnouncements: action.payload
      };
    }
    case AnnouncementActionTypes.GET_LIST_ANNOUNCEMENTS_SUCCESS: {
      return {
        ...state,
        processing: undefined,
        listAnnouncements: action.payload
      };
    }
    case AnnouncementActionTypes.GET_LIST_ANNOUNCEMENTS_FAILURE: {
      return {
        ...state,
        processing: undefined,
        error: action.payload
      };
    }
    case AnnouncementActionTypes.REMOVE_ALL_ANNOUNCEMENT: {
      return {
        ...state,
        announcements: undefined
      };
    }
    case AnnouncementActionTypes.REMOVE_ANNOUNCEMENT: {
      return {
        ...state,
        announcements: state.announcements?.filter(
          (a) => a.id !== action.payload
        )
      };
    }
    case AnnouncementActionTypes.HIDE_ANNOUNCEMENT_START: {
      return {
        ...state,
        processing: 'hiding'
      };
    }
    case AnnouncementActionTypes.HIDE_ANNOUNCEMENT_SUCCESS: {
      return {
        ...state,
        processing: undefined
      };
    }
    case AnnouncementActionTypes.HIDE_ANNOUNCEMENT_FAILURE: {
      return {
        ...state,
        processing: undefined,
        error: action.payload
      };
    }
    case AnnouncementActionTypes.UNHIDE_ANNOUNCEMENT_START: {
      return {
        ...state,
        processing: 'hiding'
      };
    }
    case AnnouncementActionTypes.UNHIDE_ANNOUNCEMENT_SUCCESS: {
      return {
        ...state,
        processing: undefined
      };
    }
    case AnnouncementActionTypes.UNHIDE_ANNOUNCEMENT_FAILURE: {
      return {
        ...state,
        processing: undefined,
        error: action.payload
      };
    }
    case AnnouncementActionTypes.DELETE_ANNOUNCEMENT_START: {
      return {
        ...state,
        processing: 'deleting',
        process: 'delete',
        success: false
      };
    }
    case AnnouncementActionTypes.DELETE_ANNOUNCEMENT_SUCCESS: {
      return {
        ...state,
        processing: undefined,
        process: 'delete',
        success: true
      };
    }
    case AnnouncementActionTypes.DELETE_ANNOUNCEMENT_FAILURE: {
      return {
        ...state,
        processing: undefined,
        process: undefined,
        success: false,
        error: action.payload
      };
    }
    case AnnouncementActionTypes.UPDATE_ANNOUNCEMENT_START: {
      return {
        ...state,
        processing: 'updating',
        process: 'update',
        submitting: true,
        success: false
      };
    }
    case AnnouncementActionTypes.UPDATE_ANNOUNCEMENT_SUCCESS: {
      return {
        ...state,
        processing: undefined,
        process: 'update',
        submitting: false,
        success: true
      };
    }
    case AnnouncementActionTypes.UPDATE_ANNOUNCEMENT_FAILURE: {
      return {
        ...state,
        processing: undefined,
        process: undefined,
        submitting: false,
        success: false,
        error: action.payload
      };
    }
    case AnnouncementActionTypes.ADD_ANNOUNCEMENT_START: {
      return {
        ...state,
        processing: 'adding',
        process: 'add',
        submitting: true,
        success: false
      };
    }
    case AnnouncementActionTypes.ADD_ANNOUNCEMENT_SUCCESS: {
      return {
        ...state,
        processing: undefined,
        process: 'add',
        submitting: false,
        success: true
      };
    }
    case AnnouncementActionTypes.ADD_ANNOUNCEMENT_FAILURE: {
      return {
        ...state,
        processing: undefined,
        process: undefined,
        submitting: false,
        success: false,
        error: action.payload
      };
    }
    case AnnouncementActionTypes.HIDE_ANNOUNCEMENT_BULK_START: {
      return {
        ...state,
        processing: 'hiding'
      };
    }
    case AnnouncementActionTypes.HIDE_ANNOUNCEMENT_BULK_SUCCESS: {
      return {
        ...state,
        processing: undefined
      };
    }
    case AnnouncementActionTypes.HIDE_ANNOUNCEMENT_BULK_FAILURE: {
      return {
        ...state,
        processing: undefined,
        error: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as AnnouncementReducer };
